// src/routes/offlineRoutes.js
import React from 'react';
import {
  FaUserPlus,
  FaEdit,
  FaSeedling,
  FaDatabase,
  FaListAlt,
  FaHome
} from 'react-icons/fa';

// Define offline routes in a format compatible with the NavbarVertical component
const offlineRoutes = [
  {
    name: 'Offline Data',
    icon: <FaDatabase size={17} />,
    to: '/offline-data',
    active: true
  },
  {
    name: 'Offline Farmer Report',
    icon: <FaUserPlus size={17} />,
    to: '/offline/farmer-report',
    active: true
  },
  {
    name: 'Offline Farmland Report',
    icon: <FaUserPlus size={17} />,
    to: '/offline/farm-report',
    active: true
  },
  {
    name: 'Offline Cultivation Report',
    icon: <FaUserPlus size={17} />,
    to: '/offline/cultivation-report',
    active: true
  }
  // {
  //   name: 'Create Farmer',
  //   icon: <FaUserPlus size={17} />,
  //   to: '/farmer/create',
  //   active: true
  // },
  // {
  //   name: 'Create Farm',
  //   icon: <FaUserPlus size={17} />,
  //   to: '/farm/create',
  //   active: true
  // },
  // {
  //   name: 'Create Cultivation',
  //   icon: <FaSeedling size={17} />,
  //   active: true,
  //   to: '/cultivation/create'
  // }
];

export default offlineRoutes;
